import filter from 'lodash/filter'
import map from 'lodash/map'
import isEmpty from 'lodash/isEmpty'
import { Icon, ShowIf } from '@ztechapps/webui.util'
import React from 'react'

export type ChatAttachmentsProps = {
  attachments?: { _id?: string; uri?: string; name?: string; isInline?: boolean }[]
}

export const ChatAttachments = ({ attachments }: ChatAttachmentsProps) => {
  // Inline images render inside the message body — only staged files get chips here.
  const visibleAttachments = filter(attachments, (attachment) => !attachment?.isInline)

  return (
    <ShowIf condition={!isEmpty(visibleAttachments)}>
      {/* A file name is one unbreakable run — `text-break` lets it wrap inside its column. */}
      <div className="mt-2 text-break">
        {map(visibleAttachments, (attachment) => (
          <span key={attachment?._id} className="m-r-md me-2">
            <Icon name="paperclip" />{' '}
            <a href={attachment?.uri} target="_blank" rel="noopener noreferrer">
              {attachment?.name}
            </a>
          </span>
        ))}
      </div>
    </ShowIf>
  )
}
